import { gql } from '@apollo/client';

export const rescueRecallPetMutation = gql`
  mutation ECOMMERCE_rescueRecallPet($input: RescueRecallPetInput!) {
    rescueRecallPet(input: $input) {
      ok
    }
  }
`;
